import { styled, SxProps, Typography } from "@mui/material";
import { ProChip } from "./Pro/ProChip";

const NewChipLabel = styled(Typography)(({ theme }) => ({
  fontSize: "10px",
  fontWeight: 500,
  fontFamily: "Poppins",
  color: theme.palette.primary.dark,
  position: "relative",
  zIndex: 2,
}));

const StyledProChip = styled(ProChip)(({ theme }) => ({
  width: "45px",
  height: "15px",
  borderRadius: "12px",
  background: theme.palette.background.proChip,
  "& :hover": {
    cursor: "default",
  },
}));

export const NewChip = (props: { sx?: SxProps }) => {
  return (
    <StyledProChip sx={props.sx || {}}>
      <NewChipLabel>Nuevo</NewChipLabel>
    </StyledProChip>
  );
};
